import fontawesome from '@fortawesome/fontawesome';

// Brands Icon
import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faLinkedinIn from '@fortawesome/fontawesome-free-brands/faLinkedinIn';
import faLinkedIn from '@fortawesome/fontawesome-free-brands/faLinkedin';
import faGooglePlusG from '@fortawesome/fontawesome-free-brands/faGooglePlusG';
import faDribbble from '@fortawesome/fontawesome-free-brands/faDribbble';
import faBehance from '@fortawesome/fontawesome-free-brands/faBehance';

// Regular Icon
import faEnvelope from '@fortawesome/fontawesome-free-regular/faEnvelope';

// Solid Icon
import faMobileAlt from '@fortawesome/fontawesome-free-solid/faMobileAlt';
import faAngleUp from '@fortawesome/fontawesome-free-solid/faAngleUp';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faFile from '@fortawesome/fontawesome-free-solid/faFile';
import faFilePdf from '@fortawesome/fontawesome-free-solid/faFilePdf';
import faFileAlt from '@fortawesome/fontawesome-free-solid/faFileAlt';
import faFileExcel from '@fortawesome/fontawesome-free-solid/faFileExcel';

// prettier-ignore
fontawesome.library.add(
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faLinkedIn,
  faGooglePlusG,
  faEnvelope,
  faMobileAlt,
  faDribbble,
  faBehance,
  faAngleUp,
  faAngleDown,
  faFile,
  faFilePdf,
  faFileAlt,
  faFileExcel,
);



// WEBPACK FOOTER //
// ./src/services/fontAwesome.js